import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../../actions/root_url';

export const updateCTNNo = ({salesOrderId, CTNNo}, success) => {
  axios({
    method: 'PUT',
    data: { ContainerNo: CTNNo },
    url: `${ROOT_URL}v1/sale/set-container-no/${salesOrderId}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    success();
  }, err => {
    alert(err);
  })
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/ctnEdit/redux.jsx